import api from '@/api';

class PropertyPremises {
  /**
   * @returns {AxiosPromise<any>}
   */
  static find(propertyId) {
    return api.get(`/properties/${propertyId}/premises`);
  }
}

export default PropertyPremises;
